import styled, { css } from 'styled-components';
import { vars } from '../../theme';
import { HBMarkerProps } from './HBMarker';

export const Marker = styled.div<HBMarkerProps>`
    position: absolute;
    right: 0px;
    width: 36px;
    height: 28px;
    background-color: ${props => props.color};
    clip-path: polygon(11px 0, 100% 0, 100% 100%, 11px 100%, 0 50%);
    ${props => (props.color === vars.colors.base.danger ? 'z-index: 1;' : '')}

    ${({ positionTop }) =>
        positionTop &&
        css`
            top: ${positionTop};
        `}
`;
